module.exports = __webpack_public_path__ + "img/digitization.0906cd71.png";